// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZXo6","bordered":"styles_bordered__306IL"};